/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';

class ErrorPanel extends React.Component {
    render () {
        let error = this.props.error,
            message = '',
            errorElement = null;

        if (error.errors) {
            if (error.errors.hasOwnProperty('perms')) {
                if (error.errors.perms.hasOwnProperty('accounts')) {
                    if (error.errors.perms.accounts.length) {
                        message = error.errors.perms.accounts[0].msg + ", is full.";
                    } else {
                        message = "Queue is full";
                    }
                } else {
                    if (this.props.pubLevel <= this.props.constants.PUB_LEVEL_1) {
                        message = (
                            <div>
                                <a href="/account/subscription/new?plan=9" title="upgrade link" alt="upgrade link">Upgrade now</a> to get access to EverQueue.
                            </div>
                        );
                    } else {
                        message = (
                            <div>
                                <a href="/account/subscription" title="upgrade link" alt="upgrade link">Upgrade now</a> to get access to EverQueue.
                            </div>
                        );
                    }

                }
            } else if (error.errors.hasOwnProperty('item')) {
                message = error.errors.item.validation;
            } else if (error.errors.hasOwnProperty('validation')) {
                if (error.errors.validation.hasOwnProperty('msg') && error.errors.validation.msg.match("duplicate")) {
                    message = "Whoa! It looks like that's already in your queue. Wait for it to post then try again.";
                } else if (error.errors.validation.hasOwnProperty('params') && error.errors.validation.params.tagID) {
                    message = "The category you selected doesn't have scheduled times for one or more of your chosen socials.";
                } else if (error.errors.validation.hasOwnProperty('msg')){
                    message = error.errors.validation.msg;
                } else {
                    message = "Your post didn't validate";
                }
            } else {
                message = "There was a problem creating your post.";
            }
        } else if (error.message !== undefined) {
            if (error.message.match("is full")) {
                if (this.props.isPlusUser() || this.props.isAgencyPlusUser()) {
                    message = (
                        <div>
                            {message} <Link to="account/subscription">Upgrade Now</Link> to increase the size your queues.
                        </div>
                    );
                }
            } else {
                message = error.message;
            }
        } else if (_.isString(error)) {
            message = error;
        } else if (typeof this.props.error === "object") {
            if (typeof this.props.error.map === "undefined") {
                message = this.props.error;
            } else {
                message = this.props.error.map((error, i) => {
                    return <p key={i}>{error}</p>
                });
            }
        }

        errorElement = (
            <div>
                {message}
            </div>
        );

        return (
            <div className="post-modal-error-panel">
                <div className="post-modal-error-header">
                    {this.props.errorHeader}
                </div>
                <div className="post-modal-errors">
                    <div className="post-modal-error-copy">
                        {errorElement}
                    </div>
                    <div className="post-modal-error-buttons">
                        <button className="btn-secondary" onClick={this.props.dismissError}>OK</button>
                    </div>
                </div>
            </div>
        )
    }
}

ErrorPanel.displayName = "ErrorPanel";

ErrorPanel.propTypes = {
    errorHeader: PropTypes.string,
    error: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
        PropTypes.object
    ]),
    dismissError: PropTypes.func
}

ErrorPanel.defaultProps = {
    errorHeader: 'There was an error.',
    error: '',
    dismissError: () => {}
}

export default ErrorPanel
